import React from "react";
import { Link } from "react-router-dom";

import * as CHQ from "chq";

import { Trans } from "app/utils";

import NotificationBody from "./NotificationBody";

type SocialSharePersonalReminderNotificationProps = {
  notification: CHQ.NotificationSocialPersonalReminder;
  tabIndex?: number;
};

const SocialSharePersonalReminderNotification:
  React.FC<SocialSharePersonalReminderNotificationProps> = ({
    notification: { entity }
  }) => (
    <NotificationBody actor={entity?.creator}>
      {" "}
      <Trans>
        Time to share your {entity?.socialType} post.
      </Trans>
      {" "}
      {entity?.approvedForSocialId && (
        <Link to={`/admin/story-reviews/published?id=${entity.approvedForSocialId}`} tabIndex={0}>
          <Trans>Click here to see it</Trans>
        </Link>
      )}
    </NotificationBody>
  );

export default SocialSharePersonalReminderNotification;
